import { Component, OnInit, Inject } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogData } from '../delete-alert/delete-alert.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-window',
  templateUrl: './alert-window.component.html',
  styleUrls: ['./alert-window.component.scss']
})
export class AlertWindowComponent implements OnInit {

  responseData: any;
  item = {
    msg: '',
  };
  btnAdditional = false;

  colorNo = 'warn';
  buttonNo = 'No';

  colorYes = 'accent';
  buttonYes = 'Yes';

  colorAdditional = 'accent';
  buttonAdditional = 'Yes';

  constructor(
    public dialogRef: MatDialogRef<AlertWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.responseData = this.data;
    this.item.msg = this.responseData.msg
    if (this.responseData.colorNo) { this.colorNo = this.responseData.colorNo; }
    if (this.responseData.buttonNo) { this.buttonNo = this.responseData.buttonNo; }

    if (this.responseData.colorYes) { this.colorYes = this.responseData.colorYes; }
    if (this.responseData.buttonYes) { this.buttonYes = this.responseData.buttonYes; }

    if (this.responseData.btnAdditional) { this.btnAdditional = this.responseData.btnAdditional; }
    if (this.responseData.colorAdditional) { this.colorAdditional = this.responseData.colorAdditional; }
    if (this.responseData.buttonAdditional) { this.buttonAdditional = this.responseData.buttonAdditional; }
  }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
